import React, { useRef, useEffect, useState } from 'react';

const EmailIframe = ({ emailBody }) => {
  const iframeRef = useRef(null);
  const [iframeHeight, setIframeHeight] = useState('0px');

  // The script to be injected into the HTML to send the document's height
  const injectedScript = `
    <script>
      (function(){
        function sendHeight() {
          var height = document.documentElement.scrollHeight;
          window.parent.postMessage({ type: 'setHeight', height: height }, '*');
        }
        window.addEventListener('load', sendHeight);
        var observer = new MutationObserver(sendHeight);
        observer.observe(document.documentElement, { childList: true, subtree: true, attributes: true });
      })();
    </script>
  `;

  // Check if emailBody already has <html> and <body> tags
  let completeHtml;
  const hasHtmlTag = /<html[\s\S]*>/i.test(emailBody) && /<\/html>/i.test(emailBody);
  const hasBodyTag = /<body[\s\S]*>/i.test(emailBody) && /<\/body>/i.test(emailBody);

  if (hasHtmlTag && hasBodyTag) {
    completeHtml = emailBody;
  } else {
    // Wrap the content in a complete HTML document
    completeHtml = `
      <html>
        <head>
          <meta charset="utf-8">
          <title>Email Content</title>
        </head>
        <body>
          ${emailBody}
        </body>
      </html>
    `;
  }

  // Insert the script before the closing </body> tag, if it exists
  let modifiedEmailBody;
  if (/<\/body>/i.test(completeHtml)) {
    modifiedEmailBody = completeHtml.replace(/<\/body>/i, injectedScript + '</body>');
  } else {
    modifiedEmailBody = completeHtml + injectedScript;
  }

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data && event.data.type === 'setHeight') {
        setIframeHeight(event.data.height + 'px');
      }
    };
    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  return (
    <iframe
      ref={iframeRef}
      title="Email Content"
      srcDoc={modifiedEmailBody}
      style={{
        width: '100%',
        height: iframeHeight,
        minHeight: '300px',
        border: 'none'
      }}
      sandbox="allow-same-origin allow-popups allow-scripts"
    />
  );
};

export default EmailIframe;
